import RoutesCreerCompte from './creer/routes';
import RoutesRecuperationLogin from './recuperer-login/routes';
import RoutesChangementResponsableLegal from './changementResponsableLegal/routes';
import { initSubRoutes } from '../../utils/router';

const RoutesCompte = initSubRoutes({
    route: '/compte',
    subroutes: {
        creer: RoutesCreerCompte,
        recupererLogin: RoutesRecuperationLogin,
        changementResponsableLegal: RoutesChangementResponsableLegal,
    },
    nom: 'Compte',
});

export default RoutesCompte;
